import ErrorSolidSVG from "@design-system/ui-icons/vanilla/ErrorSolid"
import { createIcon } from "../createIcon"

export const ErrorSolidIcon = createIcon(ErrorSolidSVG)
